// @ts-check
export const Constants = {
  Backspace: 'Backspace',
  Button: 'button',
  DateTime: 'dateTime',
  Date: 'date',
  UploadFile: 'Upload file',
  DragAndDrop: 'Drag and drop your file here',
  OnlyCsv: '(only .csv)',
  DownloadTemplate: 'Download Template',
  UploadTemplate: 'Upload Template',
  UploadProducts: 'Upload Products',
  Edit: 'edit',
  Single: 'single',
  ViewDataTable: 'View Data Table',
  Error: 'error',
  Info: 'info',
  CSV: '.csv',
  Uploading: 'uploading',
  Complete: 'complete',
  CategoryProducts: 'categoryProducts',
  UploadedProducts: 'uploadedProducts',
  UploadStoresFile: 'Upload stores file',
  UploadError: 'Upload Error',
  CorruptedFile: 'Corrupted File',
  Cancel: 'Cancel',
  Ok: 'OK',
  BulkModifiers: 'bulkPointModifiers',
  SalesTargetMedia: 'salesTargetMedia',
  RewardsTierStoreUpload: 'rewardsTierStoreUpload',
  Public: 'public',
  Private: 'private',
  Multipart: 'multipart',
  Required: 'required',
  Success: 'Success',
  ErrorForFileUpload:
    'The format being used is not correct, please use correct file format.',
  CorruptedFileTitle: 'Corrupted File:',
  CorruptedFileMessage: 'Make sure the image is not corrupted or incomplete.',
  Draft: 'Draft',
  InProgress: 'In-Progress',
  Completed: 'Completed',
  Published: 'Published',
  Unpublished: 'Unpublished',
  CategoryTable: 'categoryTable',
  SalesTarget: 'salesTarget',
  PerfectStore: 'perfectStore',
  Leaderboard: 'leaderboard',
  Quiz: 'quiz',
  Media: 'media',
  ActivityMedia: 'activityMedia',
  ReviewPublished: 'published',
  ReviewCompleted: 'completed',
  BulkDigitalCodes: 'bulkDigitalCodes',
  TitleSegments: 'Segments*',
  ToggleAllCustomers: 'All Customers',
  ToggleExclude: 'Exclude',
  LabelSegments: 'Segments',
  PlaceholderSelectSegments: 'Select Segment(s)',
  AddGroup: 'Add Group',
  DeleteGroup: 'Delete Group',
  TextAnd: 'AND',
  TextOr: 'OR',
  Loading: 'Loading...',
  IncludeModalTitleAll: 'Segments',
  IncludeModalTitleGroupPrefix: 'Select Segments for Group',
  ModalSubtitle: 'Segment List',
  ExcludeModalTitle: 'Exclude Segments',
  ExcludeLabelSelect: 'Select Segment(s)',
  BulkRewards: 'bulkRewards',
  UploadInProgressMessage:
    'This modal can be closed. Upload progress and completion can be viewed on the table.',
  GTIN: 'GTIN',
  PhysicalProduct: 'Physical Item',
  LoyaltyItem: 'Loyalty Item',
  Unlimited: 'Unlimited'
};

export const NUMBERS = {
  OneThousandTwentyFour: 1024,
  Fifty: 50,
  Hundred: 100,
  Zero: 0,
  FiveHundred: 500,
  TwoFiveSixHundred: 25600,
  One: 1,
  TwoFiveFive: 255
};

export const Size = {
  Medium: 'medium'
};

export const Variant = {
  Primary: 'primary',
  Secondary: 'secondary'
};

export const SELECTION_TYPE = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
  NONE: 'none' // to be removed after fixes
};

export const LABELS = {
  ORDER_ITEM_OVERVIEW_PAGE: {
    SubItems: 'Sub Items',
    TransactionDetails: 'Transaction Details',
    DiscountInformation: 'Discount Information'
  }
};

export const API_VERSION = {
  V1: 'v1',
  V2: 'v2'
};

export const DATE_VALIDATION_TYPE = {
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  SCHEDULE: 'schedule',
  SCHEDULE_YEAR: 'schedule_year',
  START_DATE_GREATER: 'start_date_greater',
  END_DATE_GREATER: 'end_date_greater',
  START_DATE_TODAY: 'start_date_today',
  START_DATE_REQUIRED_IF_END_DATE: 'start_date_required_if_end_date',
  END_DATE_REQUIRED_IF_START_DATE: 'end_date_required_if_start_date'
};

export const ALERT_TYPES = {
  Success: 'success',
  Error: 'error',
  Info: 'info',
  Warning: 'warning'
};

export const STATUS_VALUES = {
  Draft: 'draft',
  Published: 'Published',
  Error: 'Error'
};

export const API_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED'
};

export const STORE_SELECTOR_DROPDOWN = {
  ALL_STORES: 'all stores',
  STORE_WITHOUT_SIGN_IN: 'store without sign-in',
  EXCEL_UPLOAD: 'excel upload'
};

export const ACTION_DROPDOWN = {
  REMOVE_ALL_EXCEPT: 'remove all except',
  REMOVE_NUM_POINTS: 'remove # of points',
  REMOVE_NUM_POINTS_CHECK: 'Remove # Points',
  ADD_POINTS: 'add points'
};

export const SCHEDULE_DROPDOWN = {
  NOW: 'now',
  CUSTOM_SCHEDULE: 'custom schedule',
  END_OF_MONTH: 'end of month',
  END_OF_YEAR: 'end of year'
};

export const DATE_VALIDATION_MESSAGE = {
  END_DATE_HELPER_TEXT: 'Please select start date before selecting end date.',
  CAN_NOT_BE_GREATOR_THAN_END_DATE: "can't be greater than end date",
  // START_DATE_BE_GREATOR_THAN_END_DATE: 'Point delivery date should be after target delivery date',
  START_DATE_BE_GREATOR_THAN_END_DATE: 'should be greater than'
};

export const localCurrencyText = 'localCurrency'; // Check the Key in Actvity Reviewi

export const EXCEL_ACTION_OPTION = 'Add/Remove files from Excel';

export const VALIDATION_MESSAGES = {
  POINTS_EARNED_6_DIGITS:
    'Points Earned: Max 6 digits before decimal, 2 after.',
  POINTS_EARNED_6_DIGITS_ALT: 'Points Earned must be a value up to 6 digits',
  DAILY_LOGIN_LIMIT_2_DIGITS:
    'Daily Login Limit must be a value up to 2 digits',
  ALL_TIME_LOGIN_LIMIT_4_DIGITS:
    'All Time Login Limit must not exceed 4 digits',
  LOCAL_CURRENCY_TWO_DECIMALS:
    'Local Currency Value must be a number with up to two decimal places (e.g. 10.0, 10.50, 0.75)'
};

export const DIGIT_REGEX = {
  SIX_DIGITS: /^\d{1,6}$/,
  TWO_DIGITS: /^\d{1,2}$/,
  FOUR_DIGITS: /^\d{1,4}$/,
  SIX_DIGITS_DECIMAL_TWO_PLACES: /^\d{1,6}(\.\d{1,2})?$/,
  LOCAL_CURRENCY_TWO_DECIMALS: /^\d+(\.\d{1,2})?$/
};

export const UPLOAD_MEDIA_DEBOUNCE_TIME = 500;

export const UPLOAD_MEDIA_ACCEPTED_EXTENSIONS = '.jpg,.png,.jpeg,.webp';

export const REWARD_CATALOG_ROUTES = {
  NEW_REWARD: 'new reward',
  BULK_UPLOAD_REWARDS: 'bulk upload rewards',
  BULK_UPLOAD_DIGITAL_CODES: 'bulk upload digital codes',
  DOWNLOAD_DIGITAL_CODE_REPORT: 'download digital code report',
  DOWNLOAD: 'download'
};

export const UPLOAD_TITLES = {
  UPLOAD_DIGITAL_CODES_LIST: 'Upload Digital Codes List',
  UPLOAD_REWARDS_LIST: 'Upload Rewards List'
};

export const UPLOAD_ERROR_MESSAGES = {
  WRONG_FILE_TYPE: 'Wrong file type, please use CSV file',
  WRONG_FORMAT:
    "File Format Issue: Your file doesn't match the required format. Please check that all columns are present and all rows are filled correctly before uploading again."
};

export const NOTIFICATION_TITLES = {
  ERROR_UPLOADING_REWARD_LIST: 'Error Uploading Reward List',
  UPLOADING_REWARD_LIST: 'Uploading Reward List',
  REWARDS_LIST_SUCCESSFULLY_PUBLISHED: 'Rewards List Successfully Published',
  UPLOAD_FAILED_SUBTITLE:
    'Upload failed. Please check the required fields and format, then try again.',
  UPLOADING_SUBTITLE:
    'Your reward list is being uploaded. Please wait while we process the data.'
};

export const DIGITAL_CODES_NOTIFICATIONS = {
  CREATE_ROUTE_PREFIX: '/rewards/create/',
  PRIMARY_ACTION_ICON: 'arrow_forward',
  TOTAL_REWARDS_TEXT: 'Total Rewards',
  ZERO_LEFT: {
    TITLE: 'Reward Out of Codes',
    TEXT: 'No codes remaining. Customers are awaiting availability, please upload more.'
  },
  LOW_INVENTORY: {
    TITLE: 'Low Code Balance',
    TEXT: 'Please upload additional codes to maintain promotion availability.'
  }
};

export const FILE_UPLOAD_TEMPLATE_TYPE = {
  ACTIVITY: 'activity',
  BULK_POINT_MODIFIER: 'bulk_point_modifier',
  DIGITAL_CODES: 'digital_codes',
  LEADERBOARD: 'leaderboard',
  REWARD_CATALOG: 'reward_catalog',
  SALES_TARGET: 'sales_target',
  PERFECT_STORE: 'perfect_store'
};

export const SEARCH_DEBOUNCE_DELAY = 300;

export const DISABLE_HEADERS = {
  REWARD_CATALOG_HEADERS: ['Report', 'Inventory'],
  SALES_TARGET_HEADERS: ['Report'],
  PRODUCTS_TABLE_HEADERS: [
    'PRODUCT ID',
    'GTIN',
    'PRODUCT NAME',
    'DETAILS',
    'PRIORITY',
    ''
  ]
};

export const FILE = {
  MAX_SIZE_IMAGE: 2,
  SIZE_BYTES: 1024 * 1024,
  MAX_MULTIPLE_IMAGES_SIZE: 25,
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png']
};

export const FILE_ERROR = {
  fileUploadErrorMessage:
    'Your CSV file could not be processed due to some formatting issues. Please check the following common errors and try again',
  /** @param {number} val */
  recordsFailed: (val) => `${val} ${val === 1 ? 'record' : 'records'} failed`,
  /** @param {number} val */
  recordsSuccessfullyUploaded: (val) =>
    `${val} ${val === 1 ? 'record' : 'records'} successfully uploaded`
};

// Segment chip separator types
export const SEGMENT_CHIP_TYPE = {
  OR: 'OR',
  AND: 'AND'
};

export const SEGMENTS_WARNING_MESSAGE =
  'Selected segments will not change throughout reward even if stores within a segment change';

export const ACTIVITY_SEGMENTS_WARNING_MESSAGE =
  'Selected segments will not change throughout activity even if stores within a segment change';

export const SEGMENT_GROUP_AND_INFO_NOTE =
  'Within one group, users must be in all segments to see the rewards.';

export const SEGMENT_GROUP_OR_INFO_NOTE =
  'When there are multiple groups, users can be in either group to see the rewards.';

export const ACTIVITY_SEGMENT_GROUP_AND_INFO_NOTE =
  'Within one group, users must be in all segments to see the activity.';

export const ACTIVITY_SEGMENT_GROUP_OR_INFO_NOTE =
  'When there are multiple groups, users can be in either group to see the activity.';

export const NO_SEGMENTS_SELECTED = 'No segments selected';

export const VALIDATION_TYPES = {
  STRING: 'string',
  NUMBER: 'number',
  ALPHANUMERIC: 'alphanumeric',
  YES_NO: 'yes_no',
  DATE: 'date',
  ALPHANUMERIC_HYPHEN: 'alphanumeric_hyphen'
};

export const maxImageSizeInBytes = 70 * 1024;
export const maxVideoSizeInBytes = 100 * 1024 * 1024;

export const periodMap = {
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
  YEARLY: 'Yearly'
};

export const PERIOD_MAP = {
  Daily: 'DAILY',
  Weekly: 'WEEKLY',
  Monthly: 'MONTHLY',
  Yearly: 'YEARLY'
};
